import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="md:px-24 mx-auto px-4 text-black font-sans md:mb-20 mb-10">
      <h2 className="md:text-[36px] text-[14px] font-bold text-[#03897B] mb-4">PRIVACY POLICY</h2>
      <p className="md:text-[24px] text-[10px] font-light mb-6">Website Privacy Policy</p>
      <p className="md:text-[24px] text-[10px] font-light text-black mb-8">Updated: 30th April 2025</p>

      <div className="md:space-y-7 space-y-5 font-light text-[10px] leading-relaxed md:text-[24px]">
        <section>
          <h3 className="md:-mb-2 mb-1">1. Introduction</h3>
          <p>
            Ad-Luck ("we", "us", "our") is committed to protecting your personal information in accordance with the Protection of Personal Information Act (POPIA), No. 4 of 2013. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">2. What Information We Collect</h3>
          <p>We may collect and process the following types of personal information:</p>
          <ul className="list-disc list-inside mt-2 md:-space-y-2">
            <li>Name and surname</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>IP address</li>
            <li>Location data (if enabled)</li>
            <li>Billing and payment details (if applicable)</li>
            <li>Any other information you voluntarily provide (e.g., contact forms, newsletter sign-ups)</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">3. How We Collect Personal Information</h3>
          <p>We collect personal information directly from you in the following ways:</p>
          <ul className="list-disc list-inside mt-2 md:-space-y-2">
            <li>When you register an account</li>
            <li>When you complete a contact form or newsletter subscription</li>
            <li>When you place an order or make a payment</li>
            <li>When you browse or use our website (cookies, analytics, etc.)</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">4. Why We Collect Your Information</h3>
          <p>We use your personal information for the following purposes:</p>
          <ul className="list-disc list-inside mt-2 md:-space-y-2">
            <li>To provide and improve our services</li>
            <li>To respond to inquiries or requests</li>
            <li>To process orders and payments</li>
            <li>To communicate marketing updates (only if you've opted in)</li>
            <li>To comply with legal obligations</li>
            <li>To improve website functionality and user experience</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">5. Sharing of Personal Information</h3>
          <p>We do not sell or rent your personal information to third parties. However, we may share your information with:</p>
          <ul className="list-disc list-inside mt-2 md:-space-y-2">
            <li>Service providers (e.g., payment processors, couriers) who are bound by confidentiality agreements</li>
            <li>Legal authorities, if required by law or to protect our rights</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">6. Storage and Security</h3>
          <p>
            We take appropriate technical and organisational measures to protect your information from unauthorised access, use, disclosure, or destruction. All data is stored securely in compliance with POPIA requirements.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">7. Your Rights Under POPIA</h3>
          <p>As a data subject, you have the right to:</p>
          <ul className="list-disc list-inside mt-2 md:-space-y-2">
            <li>Access the personal information we hold about you</li>
            <li>Request correction or deletion of your information</li>
            <li>Object to or restrict processing of your information</li>
            <li>
              Lodge a complaint with the Information Regulator at <a href="https://inforegulator.org.za" className="underline text-blue-600">https://inforegulator.org.za</a>
            </li>
          </ul>
          <p className="mt-2">
            To exercise any of these rights, please contact us at:<br />
            📧 Info@adluck.co.za<br />
            📍 Midstream, Centurion, Gauteng, South Africa.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">8. Use of Cookies</h3>
          <p>
            We use cookies to enhance your browsing experience. Cookies are small text files stored on your device to help us analyze site usage and provide a personalized experience.
            You may choose to disable cookies via your browser settings, but this may affect your ability to use some features of our website.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">9. Links to Third-Party Sites</h3>
          <p>
            Our website may contain links to other websites. We are not responsible for their privacy practices. Please review their privacy policies independently.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">10. Changes to This Privacy Policy</h3>
          <p>
            We may update this policy from time to time. Changes will be posted on this page with an updated "Last Updated" date. Continued use of the website constitutes acceptance of the revised policy.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">11. Contact Information</h3>
          <p>
            If you have any questions regarding this Privacy Policy, please contact us at:<br />
            📧 Email: Info@adluck.co.za<br />
            📍 Address: Midstream, Centurion, Gauteng, South Africa
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
